import { useUserServiceProvide, useUserServiceInject } from './UserService'

export { useUserServiceInject };

export const useProvider = () => {
    useUserServiceProvide();
}